<template>
  <CheckboxWithLabel
    :class="$style.checkboxColor"
    :classNames="classNames"
    :label="control.label"
    :tooltip="getTooltip()"
    :value="value"
    @change="handleChange"
  />
</template>

<script>
import CheckboxWithLabel from 'components/FormValidation/CheckboxWithLabel.vue';
import DynamicControlsMixin from 'components/DynamicControls/mixins/DynamicControlsMixin';

export default {
  name: 'DynamicControlsCheckbox',

  components: {
    CheckboxWithLabel,
  },

  mixins: [
    DynamicControlsMixin,
  ],

  props: {
    value: {
      required: true,
      type: Boolean,
    },
  },

  computed: {
    classNames() {
      return {
        iconTooltipClassName: this.control.iconTooltipClassName || 'icon-tooltip',
      };
    },
  },

  methods: {
    handleChange(value) {
      const { displayOptions, id } = this.control;
      this.handleValueChange(id, value);

      if (displayOptions
        && displayOptions.group
        && displayOptions.group.id
        && value === true) {
        this.$emit('radio-change', this.control);
      }
    },
  },
};

</script>

<style module>
.checkboxColor label input[type='checkbox'] {
  accent-color: var(--jc-input-color);
}
</style>
